import { getDividendSectionSelector } from '@/pages/CompanyReport/components/Dividend/redux/selectors';
import type { State as CompanyState } from '@/pages/CompanyReport/redux/interface';
import type { LocationState } from 'redux-first-router';
import { shouldSkipDefer } from '@ducks/ui/selectors/shouldSkipDefer';
import { format, formatDistanceStrict } from 'date-fns';
import { pathConstructor } from '@/hooks/useCompany/utils';

const dateFormat = 'MMM dd yyyy';
interface ReduxState {
  company: CompanyState;
  location: LocationState;
}

function selector(state: ReduxState) {
  try {
    const path = pathConstructor(state.location);
    const companyId = state.company.urlToIdMapping[path];
    const dividend = getDividendSectionSelector(state, { companyId });
    const summary = state.company.summary[companyId];
    const skipDefer = shouldSkipDefer(state);
    const { dividendNextDate, dividendNextPayDate } = dividend;
    const now = Date.now();

    return {
      tickerSymbol: summary.tickerSymbol,
      companyName: summary.shortName,
      skipDefer,
      dividendNextDate,
      dividendNextPayDate,
      dividendNextDateFormatted: format(dividendNextDate, dateFormat),
      dividendNextPayDateFormatted: format(dividendNextPayDate, dateFormat),
      daysUntilNextDate: formatDistanceStrict(dividendNextDate, now, {
        unit: 'day',
      }),
      daysUntilNextPayDate: formatDistanceStrict(dividendNextPayDate, now, {
        unit: 'day',
      }),
      dividendYield: dividend.dividendYield,
      dividendYieldFormatted: dividend.dividendYieldFormatted,
      currentDividendPayoutRatioFormatted:
        dividend.currentDividendPayoutRatioFormatted,
    };
  } catch (e) {
    /** means it's loading */
    return undefined;
  }
}

export default selector;
